import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common'
import { TooltipDocsComponent } from './tooltips_doc.component';

@NgModule({
    imports: [CommonModule],
    declarations: [
        TooltipDocsComponent
    ],
    exports: [
        TooltipDocsComponent
    ]
})

export class TooltipsDocsModule {}
